var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButtonRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59695 14.3315C0.618594 6.84931 6.65379 0.848931 14.1359 0.870575C21.6181 0.89222 27.6185 6.92741 27.5968 14.4096C27.5752 21.8917 21.54 27.8921 14.0578 27.8705C6.57568 27.8488 0.575305 21.8136 0.59695 14.3315Z",
    stroke: "#dc372b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9136 14.3727L20.9393 8.38175C21.1733 8.1491 21.1743 7.7991 20.9416 7.56509C20.709 7.33108 20.359 7.33007 20.125 7.56273L14.0993 13.5537L8.10834 7.52797C7.87569 7.29396 7.52569 7.29295 7.29168 7.5256C7.05767 7.75826 7.05666 8.10826 7.28932 8.34227L13.2802 14.368L7.25456 20.3589C7.02055 20.5915 7.01954 20.9415 7.25219 21.1755C7.36852 21.2925 7.54335 21.3514 7.66002 21.3517C7.77669 21.3521 7.95185 21.2942 8.06886 21.1779L14.0945 15.187L20.0855 21.2127C20.2018 21.3297 20.3766 21.3885 20.4933 21.3889C20.61 21.3892 20.7851 21.3314 20.9021 21.215C21.1361 20.9824 21.1372 20.6324 20.9045 20.3984L14.9136 14.3727Z",
    fill: "#dc372b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonRed);
export default __webpack_public_path__ + "static/media/close-button-red.2773a215ea2477f84fb96ea3d5ec0220.svg";
export { ForwardRef as ReactComponent };